function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Forms_svg__5_b"
}, React.createElement("stop", {
  stopColor: "#F4F9FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F8E7FF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Forms_svg__4_a"
}, React.createElement("stop", {
  stopColor: "#8E9DFE",
  stopOpacity: 0.2,
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#B97AD3",
  stopOpacity: 0.2,
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%",
  id: "Forms_svg__6_c"
}, React.createElement("stop", {
  stopColor: "#A1B2FF",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#D079EC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M8 .5A7.5 7.5 0 00.5 8v34A7.5 7.5 0 008 49.5h34a7.5 7.5 0 007.5-7.5V8A7.5 7.5 0 0042 .5H8z",
  stroke: "url(#Forms_svg__4_a)",
  fill: "url(#Forms_svg__5_b)"
}), React.createElement("path", {
  d: "M37 22v6c0 1.591-1.193 3-3 3h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c.602 0 1-.47 1-1v-6c0-.53-.398-1-1-1h-5c-.602 0-1-.47-1-1s.398-1 1-1h5c1.807 0 3 1.409 3 3zm-15.273-9h.546A3.81 3.81 0 0125 14.15 3.805 3.805 0 0127.727 13h.546a1.09 1.09 0 110 2.182h-.546c-.903 0-1.726.733-1.727 1.636v16.364c.001.903.824 1.635 1.727 1.636h.546a1.09 1.09 0 110 2.182h-.546A3.805 3.805 0 0125 35.85 3.805 3.805 0 0122.273 37h-.546a1.09 1.09 0 110-2.182h.546c.903 0 1.726-.733 1.727-1.636V16.818c-.001-.903-.824-1.635-1.727-1.636h-.546a1.09 1.09 0 110-2.182zM21 29c.602 0 1 .47 1 1s-.398 1-1 1h-5c-1.807 0-3-1.409-3-3v-6c0-1.591 1.193-3 3-3h5c.602 0 1 .47 1 1s-.398 1-1 1h-5c-.602 0-1 .47-1 1v6c0 .53.398 1 1 1h5z",
  fill: "url(#Forms_svg__6_c)"
}));

var SvgForms = function SvgForms(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50
  }, props), _ref, _ref2);
};

export default SvgForms;